import _ from 'lodash';

const UUID = /\A([0-9a-fA-F]{32}|[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})\z/;

export default class PathParser {
  static parse(record, feature, container, startPath) {
    const path = startPath || '';

    const scope = [{ element: container, feature }];

    const parts = path.split('/');

    let currentContainer = container;
    let currentFeature = feature;
    let currentRepeatable = null;

    for (const part of parts) {
      if (currentRepeatable && UUID.test(part)) {
        // @ts-ignore
        currentFeature = _.find(currentRepeatable.items, (item) => item.id === part);

        if (currentFeature) {
          scope.push({ element: currentRepeatable, feature: currentFeature });
        }
      } else {
        const element = currentContainer.elementsByDataName[part];

        if (element) {
          if (element.isSectionElement && element.isDrillDown) {
            scope.push({ element, feature: currentFeature });

            currentContainer = element;
          } else if (element.isRepeatableElement) {
            // @ts-ignore
            scope.push({ element });

            currentRepeatable = currentFeature.formValues.find(element.dataName);
            currentContainer = element;
          }
        }
      }
    }

    return scope;
  }
}
